import React from 'react';
import SettingsContainer from './settingsContainers/SettingsContainer';
import SettingsContainerMobile from './settingsContainers/SettingsContainerMobile';
import styles from './styles.module.scss';

const Settings = () => (
  <>
    <div className={styles.settingsContainer}>
      <SettingsContainer />
    </div>
    <div className={styles.settingsContainerMobile}>
      <SettingsContainerMobile />
    </div>
  </>
);

export default Settings;
